export class CompanyContact {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "email",
            "baseName": "email",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CompanyContact.attributeTypeMap;
    }
    constructor() {
    }
}
